import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { selectAuthorNoteForCurrentBib } from 'app/selectors/bibs/EvaluationSelector';
import AboutTheAuthor from './AboutTheAuthor';

export class AboutTheAuthorContainer extends React.PureComponent {
  render() {
    return <AboutTheAuthor {...this.props} />;
  }
}

AboutTheAuthorContainer.propTypes = {
  authorNote: PropTypes.string
};

const mapStateToProps = state => ({
  authorNote: selectAuthorNoteForCurrentBib(state)
});

export default connect(mapStateToProps)(AboutTheAuthorContainer);
